"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _classnames = _interopRequireDefault(require("classnames"));

var _vars = require("@devsta/ui-kit/dist/common/styles/vars");

var _clientAuth = require("@devsta/client-auth");

var _clientAwsS = require("@devsta/client-aws-s3");

var _queryString = _interopRequireDefault(require("query-string"));

var _commonReact = require("@devsta/common-react");

var _lodash = _interopRequireDefault(require("lodash.debounce"));

var _lodash2 = _interopRequireDefault(require("lodash.get"));

var _Filters = _interopRequireDefault(require("./Filters"));

var _statusMap = _interopRequireDefault(require("../constants/statusMap"));

var _TrafficList = _interopRequireDefault(require("./TrafficList"));

var _colors = require("../../../common/styles/colors");

require("../styles/manage-traffic.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var MY_QUEUE = 'MY_QUEUE';
var GLOBAL_QUEUE = 'GLOBAL_QUEUE';

function filters(userId, queueType) {
  var baseFilters = {
    STATUS: [{
      label: 'All',
      value: 'All',
      selectedDefault: true,
      statKey: 'total'
    }, {
      label: _statusMap.default.DRAFT,
      value: 'DRAFT',
      statKey: 'status.DRAFT'
    }, {
      label: _statusMap.default.PENDING_MASTER,
      value: 'PENDING_MASTER',
      statKey: 'status.PENDING_MASTER'
    }, {
      label: _statusMap.default.EDITING,
      value: 'EDITING',
      statKey: 'status.EDITING'
    }, {
      label: _statusMap.default.INTERNAL_REVIEW,
      value: 'INTERNAL_REVIEW',
      statKey: 'status.INTERNAL_REVIEW'
    }, {
      label: _statusMap.default.PENDING_REVIEW,
      value: 'PENDING_REVIEW',
      statKey: 'status.PENDING_REVIEW'
    }, {
      label: _statusMap.default.APPROVED,
      value: 'APPROVED',
      statKey: 'status.APPROVED'
    }, {
      label: _statusMap.default.ON_HOLD,
      value: 'ON_HOLD',
      statKey: 'status.ON_HOLD'
    }],
    DIFFICULTY: [{
      label: 'All',
      value: 'All',
      selectedDefault: true,
      statKey: 'total'
    }, {
      label: 'Easy',
      value: 'EASY',
      statKey: 'difficulty.EASY'
    }, {
      label: 'Moderate',
      value: 'MODERATE',
      statKey: 'difficulty.MODERATE'
    }, {
      label: 'Hard',
      value: 'HARD',
      statKey: 'difficulty.HARD'
    }, {
      label: 'Unknown',
      value: 'UNKNOWN',
      statKey: 'difficulty.UNKNOWN'
    }]
  };

  if (queueType === MY_QUEUE) {
    return baseFilters;
  }

  return _objectSpread({
    EDITOR: [].concat(_toConsumableArray(userId ? [{
      label: 'Assigned to Me',
      value: "".concat(userId),
      statKey: 'user'
    }] : []), [{
      label: 'Assigned to Everyone',
      value: 'All',
      selectedDefault: true,
      statKey: 'total'
    }, {
      label: 'Unassigned',
      value: null,
      statKey: 'unassigned'
    }])
  }, baseFilters);
}

function VideoSummaryCard(_ref) {
  var label = _ref.label,
      count = _ref.count,
      status = _ref.status;
  return (/*#__PURE__*/_react.default.createElement("div", {
      className: "manage-traffic__video-summary"
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: count ? {
        color: _colors.STATUS_COLORS_MAP[status.name]
      } : {}
    }, count), /*#__PURE__*/_react.default.createElement("p", null, label))
  );
}

function resolveProfileImages(outputs, apiClient) {
  if (!outputs.length) {
    return outputs;
  }

  try {
    return Promise.all(outputs.map( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(output) {
        var video, creator, organisationId;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                video = output.video;
                creator = video.creator, organisationId = video.organisation.organisationId;
                _context.t0 = _objectSpread;
                _context.t1 = {};
                _context.t2 = output;
                _context.t3 = _objectSpread;
                _context.t4 = {};
                _context.t5 = video;
                _context.next = 10;
                return (0, _clientAwsS.replaceBucketKeysWithUrls)({
                  apiClient: apiClient,
                  data: creator,
                  organisationId: organisationId,
                  substitutedKeys: ['imageUrl']
                });

              case 10:
                _context.t6 = _context.sent;
                _context.t7 = {
                  creator: _context.t6
                };
                _context.t8 = (0, _context.t3)(_context.t4, _context.t5, _context.t7);
                _context.t9 = {
                  video: _context.t8
                };
                return _context.abrupt("return", (0, _context.t0)(_context.t1, _context.t2, _context.t9));

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }()));
  } catch (e) {
    return outputs;
  }
}

function getQueuePreference() {
  return localStorage.getItem('TRAFFIC_QUEUE');
}

var ManageTraffic = /*#__PURE__*/function (_Component) {
  _inherits(ManageTraffic, _Component);

  var _super = _createSuper(ManageTraffic);

  function ManageTraffic(props) {
    var _this;

    _classCallCheck(this, ManageTraffic);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var queuePreference;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.fetchStats();

              _this.fetchEditors();

              _context2.next = 4;
              return _this.applyUrlFilters();

            case 4:
              queuePreference = getQueuePreference();

              if (!(queuePreference && queuePreference === GLOBAL_QUEUE)) {
                _context2.next = 7;
                break;
              }

              return _context2.abrupt("return");

            case 7:
              // Initialise traffic with my queue filter
              _this.updateFilters({
                EDITOR: [_clientAuth.credentials.get().user.userId]
              });

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "updateFilters", function (updatedFilter) {
      var _this$props = _this.props,
          history = _this$props.history,
          location = _this$props.history.location;
      var selectedFilters = _this.state.selectedFilters;

      var updatedFilters = _objectSpread({}, selectedFilters, {}, updatedFilter);

      var queryParams = Object.keys(updatedFilters).reduce(function (updatedQueryParams, key) {
        var paramsArray = updatedFilters[key].map(function (value) {
          return value === null ? 'null' : value;
        });
        return paramsArray.length ? _objectSpread({}, updatedQueryParams, _defineProperty({}, key, paramsArray)) : updatedQueryParams;
      }, {}); // $FlowFixMe query-string ArrayFormat type do not support 'comma' enum for some reason

      history.replace("".concat(location.pathname, "?").concat(_queryString.default.stringify(queryParams, {
        arrayFormat: 'comma'
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "resetFilters", function () {
      var _this$props2 = _this.props,
          history = _this$props2.history,
          location = _this$props2.history.location;
      history.replace("".concat(location.pathname));
    });

    _defineProperty(_assertThisInitialized(_this), "applyUrlFilters", function () {
      var urlParams = _this.props.urlParams; // $FlowFixMe

      var queryParams = _queryString.default.parse(urlParams, {
        arrayFormat: 'comma'
      });

      var selectedFilters = Object.keys(queryParams).reduce(function (filtersObj, key) {
        var paramsArray = Array.isArray(queryParams[key]) ? queryParams[key] : [queryParams[key]];
        return _objectSpread({}, filtersObj, _defineProperty({}, key, paramsArray.map(function (value) {
          return value === 'null' ? null : value;
        })));
      }, {});
      return new Promise(function (resolve) {
        _this.setState({
          selectedFilters: selectedFilters
        }, function () {
          _this.fetchData();

          resolve();
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onFiltersChange", function (listFilters) {
      _this.setState({
        searchTerm: listFilters.searchTerm
      }, _this.fetchData);
    });

    _defineProperty(_assertThisInitialized(_this), "fetchEditors", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var getEditors, userId, _yield$getEditors, data, error, editors;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              getEditors = _this.props.getEditors;
              userId = _this.state.user.userId;
              _context3.prev = 2;
              _context3.next = 5;
              return getEditors({
                userId: userId
              });

            case 5:
              _yield$getEditors = _context3.sent;
              data = _yield$getEditors.data;
              error = _yield$getEditors.error;

              if (!(error || !data)) {
                _context3.next = 10;
                break;
              }

              return _context3.abrupt("return", void _this.setState({
                error: true
              }));

            case 10:
              editors = data.getUsers;

              _this.setState({
                editors: editors
              });

              _context3.next = 17;
              break;

            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](2);
              return _context3.abrupt("return", void _this.setState({
                error: true
              }));

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[2, 14]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "fetchStats", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var getTrafficOutputStats, userId, _yield$getTrafficOutp, data, error;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              getTrafficOutputStats = _this.props.getTrafficOutputStats;
              userId = _this.state.user.userId;
              _context4.next = 4;
              return getTrafficOutputStats({
                userId: userId
              });

            case 4:
              _yield$getTrafficOutp = _context4.sent;
              data = _yield$getTrafficOutp.data;
              error = _yield$getTrafficOutp.error;

              if (!(!data || !data.getTrafficOutputStats || error)) {
                _context4.next = 9;
                break;
              }

              return _context4.abrupt("return", void _this.setState({
                error: true
              }));

            case 9:
              _this.setState({
                stats: data.getTrafficOutputStats
              });

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));

    _defineProperty(_assertThisInitialized(_this), "fetchData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var _this$props3, getTrafficOutputs, apiClient, _this$state, selectedFilters, searchTerm, _yield$getTrafficOutp2, data, error, _data$getTrafficOutpu, count, outputs, outputsWithImages;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this$props3 = _this.props, getTrafficOutputs = _this$props3.getTrafficOutputs, apiClient = _this$props3.apiClient;
              _this$state = _this.state, selectedFilters = _this$state.selectedFilters, searchTerm = _this$state.searchTerm;

              _this.setState({
                loading: true
              });

              _context5.next = 5;
              return getTrafficOutputs(_objectSpread({}, selectedFilters, {
                searchTerm: searchTerm,
                limit: 10,
                offset: 0
              }));

            case 5:
              _yield$getTrafficOutp2 = _context5.sent;
              data = _yield$getTrafficOutp2.data;
              error = _yield$getTrafficOutp2.error;

              if (!(!data || error || !data.getTrafficOutputs)) {
                _context5.next = 10;
                break;
              }

              return _context5.abrupt("return", void _this.setState({
                error: true
              }));

            case 10:
              _data$getTrafficOutpu = data.getTrafficOutputs, count = _data$getTrafficOutpu.count, outputs = _data$getTrafficOutpu.outputs;
              _context5.next = 13;
              return resolveProfileImages(outputs, apiClient);

            case 13:
              outputsWithImages = _context5.sent;

              _this.setState({
                loading: false,
                data: {
                  getTrafficOutputs: {
                    count: count,
                    outputs: outputsWithImages
                  }
                },
                numResults: data.getTrafficOutputs.count
              });

            case 15:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    })));

    _defineProperty(_assertThisInitialized(_this), "loadMoreResults", /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref7) {
        var currentOffset, _this$state2, existingData, selectedFilters, searchTerm, _this$props4, getTrafficOutputs, apiClient, oldOutputs, _yield$getTrafficOutp3, data, error, _data$getTrafficOutpu2, count, newOutputs, newOutputsWithImages;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                currentOffset = _ref7.currentOffset;
                _this$state2 = _this.state, existingData = _this$state2.data, selectedFilters = _this$state2.selectedFilters, searchTerm = _this$state2.searchTerm;

                if (existingData) {
                  _context6.next = 4;
                  break;
                }

                return _context6.abrupt("return");

              case 4:
                _this$props4 = _this.props, getTrafficOutputs = _this$props4.getTrafficOutputs, apiClient = _this$props4.apiClient;
                oldOutputs = existingData.getTrafficOutputs.outputs;
                _context6.next = 8;
                return getTrafficOutputs(_objectSpread({}, selectedFilters, {
                  searchTerm: searchTerm,
                  limit: 10,
                  offset: currentOffset
                }));

              case 8:
                _yield$getTrafficOutp3 = _context6.sent;
                data = _yield$getTrafficOutp3.data;
                error = _yield$getTrafficOutp3.error;

                if (!(!data || !data.getTrafficOutputs || error)) {
                  _context6.next = 13;
                  break;
                }

                return _context6.abrupt("return");

              case 13:
                _data$getTrafficOutpu2 = data.getTrafficOutputs, count = _data$getTrafficOutpu2.count, newOutputs = _data$getTrafficOutpu2.outputs;
                _context6.next = 16;
                return resolveProfileImages(newOutputs, apiClient);

              case 16:
                newOutputsWithImages = _context6.sent;

                _this.setState({
                  data: {
                    getTrafficOutputs: {
                      count: count,
                      outputs: oldOutputs.concat(newOutputsWithImages)
                    }
                  }
                });

              case 18:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x2) {
        return _ref8.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "setTrafficRef", function (ref) {
      _this._trafficRef = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "getTrafficRef", function () {
      return _this._trafficRef;
    });

    _defineProperty(_assertThisInitialized(_this), "refreshQueue", function () {
      _this.fetchStats();

      _this.fetchData();
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeQueueType", function (_ref9) {
      var selectedTabIndex = _ref9.selectedTabIndex;
      localStorage.setItem('TRAFFIC_QUEUE', selectedTabIndex === 0 ? MY_QUEUE : GLOBAL_QUEUE);

      if (selectedTabIndex === 0) {
        _this.updateFilters({
          EDITOR: [_clientAuth.credentials.get().user.userId]
        });

        return void _this.setState({
          queueType: MY_QUEUE
        });
      }

      _this.updateFilters({
        EDITOR: []
      });

      _this.setState({
        queueType: GLOBAL_QUEUE
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onHoldActionChange", function (_ref10) {
      var outputId = _ref10.outputId,
          status = _ref10.status,
          onHoldDate = _ref10.onHoldDate,
          versions = _ref10.versions;
      var data = _this.state.data;

      if (!data) {
        return;
      }

      var _data$getTrafficOutpu3 = data.getTrafficOutputs,
          count = _data$getTrafficOutpu3.count,
          outputs = _data$getTrafficOutpu3.outputs; // TODO need to update stats + optionally hide if it no longer matches the filters

      _this.setState({
        data: {
          getTrafficOutputs: {
            count: count,
            outputs: outputs.map(function (output) {
              return output.outputId === outputId ? _objectSpread({}, output, {
                onHoldDate: onHoldDate,
                status: status,
                versions: versions
              }) : output;
            })
          }
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDueDateChange", function (_ref11) {
      var outputId = _ref11.outputId,
          versionId = _ref11.versionId,
          dueDate = _ref11.dueDate;
      var data = _this.state.data;

      if (!data) {
        return;
      }

      var _data$getTrafficOutpu4 = data.getTrafficOutputs,
          count = _data$getTrafficOutpu4.count,
          outputs = _data$getTrafficOutpu4.outputs;

      _this.setState({
        data: {
          getTrafficOutputs: {
            count: count,
            outputs: outputs.map(function (output) {
              return output.outputId === outputId ? _objectSpread({}, output, {
                versions: output.versions.map(function (version) {
                  return version.versionId === versionId ? _objectSpread({}, version, {
                    dueDate: dueDate
                  }) : version;
                })
              }) : output;
            })
          }
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMoveToBuilding", function (videoId) {
      var data = _this.state.data;

      if (!data) {
        return;
      }

      var _data$getTrafficOutpu5 = data.getTrafficOutputs,
          count = _data$getTrafficOutpu5.count,
          outputs = _data$getTrafficOutpu5.outputs;

      _this.setState({
        data: {
          getTrafficOutputs: {
            count: count,
            outputs: outputs.map(function (output) {
              return output.videoId === videoId ? _objectSpread({}, output, {
                status: _objectSpread({}, output.status, {
                  name: 'DRAFT'
                })
              }) : output;
            })
          }
        }
      });
    });

    var _credentials$get = _clientAuth.credentials.get(),
        user = _credentials$get.user;

    _this.state = {
      loading: false,
      selectedFilters: {},
      numResults: 0,
      editors: [],
      searchTerm: '',
      user: user,
      queueType: getQueuePreference() || MY_QUEUE
    };
    return _this;
  }

  _createClass(ManageTraffic, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref12) {
      var prevUrlparams = _ref12.urlParams;
      var urlParams = this.props.urlParams;

      if (prevUrlparams === urlParams) {
        return;
      }

      this.applyUrlFilters();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          history = _this$props5.history,
          containerSize = _this$props5.containerSize;
      var _this$state3 = this.state,
          numResults = _this$state3.numResults,
          stats = _this$state3.stats,
          data = _this$state3.data,
          loading = _this$state3.loading,
          editors = _this$state3.editors,
          user = _this$state3.user,
          error = _this$state3.error,
          selectedFilters = _this$state3.selectedFilters,
          queueType = _this$state3.queueType;
      var userId = user.userId,
          firstName = user.firstName;

      if (error) {
        return (/*#__PURE__*/_react.default.createElement(_commonReact.Error, null)
        );
      }

      return (/*#__PURE__*/_react.default.createElement("div", {
          ref: this.setTrafficRef,
          className: (0, _classnames.default)('manage-traffic', 'page', {
            'manage-traffic--medium': containerSize.width < _vars.NUMERIC_MEDIA_SIZES.medium
          })
        }, /*#__PURE__*/_react.default.createElement(_uiKit.PageHeader, {
          title: "Manage Traffic",
          subtitle: "Shootsta",
          actionBtnText: "Refresh Queue",
          actionBtnOnClick: this.refreshQueue,
          actionBtnBusy: loading && data
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "manage-traffic__body page__content"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "manage-traffic__body__summary"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "manage-traffic__body__summary__header"
        }, /*#__PURE__*/_react.default.createElement("p", null, "What\u2019s up, ".concat(firstName, "?")), /*#__PURE__*/_react.default.createElement("p", null, "Here\u2019s what you have on today!")), /*#__PURE__*/_react.default.createElement("div", {
          className: "manage-traffic__body__summary__cards"
        }, /*#__PURE__*/_react.default.createElement(VideoSummaryCard, {
          label: "Editing in-progress",
          count: (0, _lodash2.default)(stats, "".concat(queueType === GLOBAL_QUEUE ? 'global' : 'user', ".status.EDITING"), 0),
          status: "EDITING"
        }), /*#__PURE__*/_react.default.createElement(VideoSummaryCard, {
          label: "Pending review",
          count: (0, _lodash2.default)(stats, "".concat(queueType === GLOBAL_QUEUE ? 'global' : 'user', ".status.INTERNAL_REVIEW"), 0),
          status: "PENDING_REVIEW"
        }), /*#__PURE__*/_react.default.createElement(VideoSummaryCard, {
          label: "On-Hold",
          count: (0, _lodash2.default)(stats, "".concat(queueType === GLOBAL_QUEUE ? 'global' : 'user', ".status.ON_HOLD"), 0),
          status: "ON_HOLD"
        }))), /*#__PURE__*/_react.default.createElement("div", {
          className: "manage-traffic__body__list"
        }, /*#__PURE__*/_react.default.createElement(_Filters.default, {
          containerSize: containerSize,
          numResults: numResults,
          stats: stats,
          filters: filters(userId, queueType),
          selectedFilters: selectedFilters,
          updateFilters: this.updateFilters,
          resetFilters: this.resetFilters
        }), /*#__PURE__*/_react.default.createElement(_TrafficList.default, {
          getTrafficRef: this.getTrafficRef,
          onFiltersChange: (0, _lodash.default)(this.onFiltersChange, 200),
          history: history,
          outputs: data ? data.getTrafficOutputs.outputs : [],
          loading: loading,
          loadMoreResults: this.loadMoreResults,
          totalResults: numResults,
          editors: editors,
          onHoldActionChange: this.onHoldActionChange,
          onDueDateChange: this.onDueDateChange,
          onMoveToBuilding: this.onMoveToBuilding,
          onChangeQueueType: this.onChangeQueueType,
          queueTypeIndex: queueType === GLOBAL_QUEUE ? 1 : 0
        }))))
      );
    }
  }]);

  return ManageTraffic;
}(_react.Component);

var _default = ManageTraffic;
exports.default = _default;